import { UpdateModel } from './update.model';

export class UpdateFactory {
  public static new(data?: Partial<UpdateModel>): UpdateModel {
    return new UpdateModel(data);
  }

  public static getModel(): any {
    return UpdateModel;
  }

  public static getPath(): string {
    return 'updates';
  }
}
